import { render } from "./pr-detail.vue?vue&type=template&id=c9f06766&scoped=true"
import script from "./pr-detail.vue?vue&type=script&lang=js"
export * from "./pr-detail.vue?vue&type=script&lang=js"

import "./pr-detail.vue?vue&type=style&index=0&id=c9f06766&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9f06766"]])

export default __exports__